<template>
  <a v-if="href && href.length > 0" :class="badgeClass" :href="href" target="_blank">
    <font-awesome-icon :icon="icon" />
    PDF
    <font-awesome-icon :icon="['fal', 'paperclip']" />
  </a>
</template>

<script type="text/babel">
export default {
  props: {
    href: {
      default: "",
    },

    size: {
      type: String,
      required: false,
      default: "badge-large",
    },
  },

  data() {
    return {
      color: "badge-bordered-blue",
      icon: ["fal", "file-pdf"],
    };
  },

  computed: {
    badgeClass() {
      return `badge ${this.color} ${this.size}`;
    },
  },
};
</script>
